import moment from 'moment';
import ViewBase from '../../view-base.view';
import aiJpoModel from '../../../models/schedule/ai-jpo.model';
import languageModel from '../../../models/language.model';
import paginationComponent from '../../../components/pagination/pagination.component';

export default function DetailsTabView() {
    ViewBase.call(this);

    let details = [];
    let totalCount = 0;
    let pageIndex = 1;
    let pageSize = 10;
    let filter = {};

    let zones = [];
    let groups = [];
    let selectedZone = '';
    let selectedGroup = '';

    let dateFrom = '';
    let dateTo = '';

    let setDefaultDates = () => {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const lastDay = new Date(y, now.getMonth() + 1, 0).getDate();
        dateFrom = `${y}-${m}-01`;
        dateTo = `${y}-${m}-${String(lastDay).padStart(2, '0')}`;
    };

    let loadDropdowns = () => {
        aiJpoModel.getZonesDropdown({
            countryCode: filter.countryCode,
            bu: filter.bu
        })
            .then((result) => {
                zones = result || [];
            })
            .catch(() => { });
    };

    let loadGroups = () => {
        let req = {
            countryCode: filter.countryCode,
            bu: filter.bu
        };
        if (selectedZone) req.zoneId = selectedZone;

        aiJpoModel.getGroupsDropdown(req)
            .then((result) => {
                groups = result || [];
            })
            .catch(() => { });
    };

    let loadDetails = () => {
        this.showLoading();
        let req = {
            countryCode: filter.countryCode,
            bu: filter.bu,
            dateFrom: dateFrom,
            dateTo: dateTo,
            page: pageIndex,
            pageSize: pageSize
        };
        if (selectedZone) req.zoneId = selectedZone;
        if (selectedGroup) req.groupId = selectedGroup;

        aiJpoModel.getDetails(req)
            .then((result) => {
                details = result.items || [];
                totalCount = result.total || 0;
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    };

    let onZoneChange = () => {
        selectedGroup = '';
        groups = [];
        loadGroups();
        pageIndex = 1;
        loadDetails();
    };

    let onGroupChange = () => {
        pageIndex = 1;
        loadDetails();
    };

    let onPageChanged = (p) => {
        pageIndex = p;
        loadDetails();
    };

    let onPageSizeChanged = (p, ps) => {
        pageIndex = p;
        pageSize = ps;
        loadDetails();
    };

    let onSearch = () => {
        pageIndex = 1;
        loadDetails();
    };

    return {
        oninit: ({ attrs }) => {
            filter = attrs.filter;
            setDefaultDates();
            loadDropdowns();
            loadDetails();
        },
        onupdate: ({ attrs }) => {
            if (attrs.searchVersion !== filter._searchVersion) {
                filter = attrs.filter;
                filter._searchVersion = attrs.searchVersion;
                selectedZone = '';
                selectedGroup = '';
                groups = [];
                loadDropdowns();
                pageIndex = 1;
                loadDetails();
            }
        },
        view: () => {
            return [
                // Filter bar
                m('.card.mb-3',
                    m('.card-body',
                        m('.row.g-4',
                            m('.col-sm-6.col-lg-3',
                                m('label.form-label', languageModel.getText('', 'Date From')),
                                m('input.form-control.form-control-bg', {
                                    type: 'date',
                                    value: dateFrom,
                                    onchange: (e) => { dateFrom = e.target.value; }
                                })
                            ),
                            m('.col-sm-6.col-lg-3',
                                m('label.form-label', languageModel.getText('', 'Date To')),
                                m('input.form-control.form-control-bg', {
                                    type: 'date',
                                    value: dateTo,
                                    onchange: (e) => { dateTo = e.target.value; }
                                })
                            ),
                            m('.col-sm-6.col-lg-3',
                                m('label.form-label', languageModel.getText('', 'Zone')),
                                m('select.form-control.form-control-bg', {
                                    value: selectedZone,
                                    onchange: (e) => { selectedZone = e.target.value; onZoneChange(); }
                                }, [
                                    m('option', { value: '' }, languageModel.getText('', 'ALL')),
                                    zones.map((z) => m('option', { value: z.id }, z.name || ''))
                                ])
                            ),
                            m('.col-sm-6.col-lg-3',
                                m('label.form-label', languageModel.getText('', 'Group')),
                                m('select.form-control.form-control-bg', {
                                    value: selectedGroup,
                                    onchange: (e) => { selectedGroup = e.target.value; onGroupChange(); }
                                }, [
                                    m('option', { value: '' }, languageModel.getText('', 'ALL')),
                                    groups.map((g) => m('option', { value: g.id }, g.name || ''))
                                ])
                            ),
                            m('.col-12.d-flex.justify-content-end.gap-2',
                                m('button.btn.btn-primary', { onclick: onSearch }, languageModel.getText('', 'Search'))
                            )
                        )
                    )
                ),

                // Details table
                m('.card',
                    m('.card-body',
                        m('.table-responsive',
                            m('table.table.table-bordered',
                                m('thead.thead-bggrey',
                                    m('tr.align-middle', [
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Zone')),
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Group')),
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Supervisor')),
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Store Code')),
                                        m('th', { scope: 'col', style: 'width: 80px;' }, languageModel.getText('', 'Grade')),
                                        m('th', { scope: 'col', style: 'width: 110px;' }, languageModel.getText('', 'Schedule Date')),
                                        m('th', { scope: 'col', style: 'width: 100px;' }, languageModel.getText('', 'Start Time')),
                                        m('th', { scope: 'col', style: 'width: 100px;' }, languageModel.getText('', 'End Time')),
                                        m('th', { scope: 'col', style: 'width: 90px;' }, languageModel.getText('', 'Travel (min)')),
                                        m('th', { scope: 'col', style: 'width: 90px;' }, languageModel.getText('', 'Dwell (min)')),
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Visit Plan Type')),
                                        m('th', { scope: 'col', style: 'width: 110px;' }, languageModel.getText('', 'Visit Status')),
                                    ])
                                ),
                                m('tbody',
                                    details.length === 0 &&
                                        m('tr.align-middle',
                                            m('td', { colspan: '12' }, languageModel.getText('', 'No records found.'))
                                        ),
                                    details.map((r) =>
                                        m('tr', [
                                            m('td', r.zoneName || ''),
                                            m('td', r.groupName || ''),
                                            m('td', r.supervisor || ''),
                                            m('td', r.storeCode || ''),
                                            m('td.text-center',
                                                m('span.ai-jpo-grade.ai-jpo-grade-' + (r.grade || '').toLowerCase(), r.grade || '')
                                            ),
                                            m('td', r.scheduleDate || ''),
                                            m('td', r.startTime || ''),
                                            m('td', r.endTime || ''),
                                            m('td.text-end', r.travelMinutes ?? ''),
                                            m('td.text-end', r.dwellMinutes ?? ''),
                                            m('td', r.visitPlanType || ''),
                                            m('td.text-center',
                                                m('span.ai-jpo-status-badge', r.visitStatus || '')
                                            ),
                                        ])
                                    )
                                )
                            )
                        ),
                        !this._isLoading &&
                            m('.px-3.pt-2',
                                m(paginationComponent, {
                                    currentPage: pageIndex,
                                    pageSize: pageSize,
                                    totalItems: totalCount,
                                    onPageChanged: onPageChanged,
                                    onPageSizeChanged: onPageSizeChanged
                                })
                            )
                    )
                )
            ];
        }
    };
}
